import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="py-12 bg-[#0a0a0a] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {/* Left - Logo & Powered by */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <img src="https://customer-assets.emergentagent.com/job_20a21bfd-b8fc-46d5-80c1-3ef1449007db/artifacts/gnn6v1fg_Gotta%20Second-white.png" alt="GottaSecond" className="h-8 w-auto" />
            <span className="text-sm text-white/40">Powered by Studio Lifesaver</span>
          </div>
          
          {/* Middle - Links */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/40">
            <Link to="/help" className="hover:text-white transition-colors">Help & Feedback</Link>
            <a href="/articles" className="hover:text-white transition-colors">Articles</a>
            <Link to="/photographer-of-the-week" className="hover:text-white transition-colors">Photographer of the Week</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/accessibility" className="hover:text-white transition-colors">Accessibility</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link>
            <Link to="/privacy#do-not-sell" className="hover:text-white transition-colors">Do Not Sell My Info</Link>
          </div>
          
          {/* Right - Copyright */}
          <div className="flex justify-center md:justify-end">
            <span className="text-sm text-white/40">© 2026 Studio Lifesaver LLC</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
